import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type CtaButtonProps = {
  children: React.ReactNode;
  size?: 'md' | 'lg';
  className?: string;
};
export function CtaButton({
  children,
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-9 py-4 text-[13px]' : 'px-7 py-3.5 text-[12px]';
  return <a href="#offerta" className={`group inline-flex items-center justify-center gap-2.5 rounded-full bg-brand font-sans font-bold uppercase tracking-[0.14em] text-white shadow-lift transition-[background-color,transform] duration-150 ease-out hover:bg-brand-dark active:translate-y-px focus:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-cream-100 ${sizing} ${className}`} data-id="element-43" data-mp="cjzktof84z1v">
      {children}
      <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-44" data-mp="19aa2pjvxq2t3" />
    </a>;
}